import NTopNBottom from '../../components/NTopNBottom'

import navColor from '../../assets/withYou/nav/color.jpg'
import navBg from '../../assets/withYou/nav/nav_bg.png'

import far1 from '../../assets/withYou/nav/far1.png'
import far1_active from '../../assets/withYou/nav/far1_active.png'
import far2 from '../../assets/withYou/nav/far2.png'
import far2_active from '../../assets/withYou/nav/far2_active.png'
import far3 from '../../assets/withYou/nav/far3.png'
import far3_active from '../../assets/withYou/nav/far3_active.png'
import son1 from '../../assets/withYou/nav/son1.png'
import son1_active from '../../assets/withYou/nav/son1_active.png'
import son2 from '../../assets/withYou/nav/son2.png'
import son2_active from '../../assets/withYou/nav/son2_active.png'
import son3 from '../../assets/withYou/nav/son3.png'
import son3_active from '../../assets/withYou/nav/son3_active.png'
import son4 from '../../assets/withYou/nav/son4.png'
import son4_active from '../../assets/withYou/nav/son4_active.png'
import son5 from '../../assets/withYou/nav/son5.png'
import son5_active from '../../assets/withYou/nav/son5_active.png'
import son6 from '../../assets/withYou/nav/son6.png'
import son6_active from '../../assets/withYou/nav/son6_active.png'

import bannerImg from '../../assets/withYou/banner.jpg'

import p1_1 from '../../assets/withYou/ctn/1_1.jpg'
import p1_2 from '../../assets/withYou/ctn/1_2.jpg'
import p2_1 from '../../assets/withYou/ctn/2_1.jpg'
import p3_1 from '../../assets/withYou/ctn/3_1.jpg'
import p3_2 from '../../assets/withYou/ctn/3_2.jpg'
import p4_1 from '../../assets/withYou/ctn/4_1.jpg'
import p4_2 from '../../assets/withYou/ctn/4_2.jpg'
import p5_1 from '../../assets/withYou/ctn/5_1.jpg'
import p6_1 from '../../assets/withYou/ctn/6_1.jpg'
import p7_1 from '../../assets/withYou/ctn/7_1.jpg'
import p8_1 from '../../assets/withYou/ctn/8_1.jpg'
import p9_1 from '../../assets/withYou/ctn/9_1.jpg'
import p10_1 from '../../assets/withYou/ctn/10_1.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'

import calcRemFn from '../calcRem'


// 需要手动修改proId 
const top1_i1 = IS_PROD ? '96223' : '96223'
const top1_i2 = top1_i1
const top1_i3 = top1_i1
const top2_i1 = IS_PROD ? '96224' : '96224'
const top2_i2 = top2_i1
const top2_i3 = top2_i1
const top2_i4 = top2_i1
const top3_i1 = IS_PROD ? '96225' : '96225'
const top3_i2 = top3_i1
const top3_i3 = top3_i1
const top3_i4 = top3_i1

const navCss = {
  navWrap: {
    minHeight: calcRemFn(128),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(128),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    position: 'absolute',
    bottom: calcRemFn(24),
    padding: `0 ${calcRemFn(22)} 0`,
    width: '100%',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
  },
  topBtnBaseCss: {
    width: calcRemFn(108),
    height: calcRemFn(46),
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(18)} ${calcRemFn(66)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(59),
    height: calcRemFn(17),
  },
  LineCss2: {
    width: '1px',
    height: calcRemFn(8),
    backgroundColor: '#494949'
  }
}

const navData = {
  component: NTopNBottom,
  withYouSpec: true,
  showLine2: true,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: top1_i1
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: top1_i2
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: top1_i3
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: top2_i1
      },
      {
        key: '_i2',
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: top2_i2
      },
      {
        key: '_i3',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: top2_i3
      },
      {
        key: '_i4',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: top2_i4
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: top3_i1
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: top3_i2
      },
      {
        key: '_i3',
        show: true,
        img: son6,
        img_actived: son6_active,
        prodId: top3_i3
      },
      {
        key: '_i4',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: top3_i4
      },
    ]
  }
}

const pictures = [
  {
    id: top1_i1,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
    ],
    name: '单人-霓物语'
  },
  {
    id: top1_i2,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p1_2,
    ]
  },
  {
    id: top1_i3,
    type: 'blue',
    ref: 'top1_i3',
    farName: 'top1',
    sonName: '_i3',
    son: [
      p2_1,
    ]
  },
  {
    id: top2_i1,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p3_1,
      p3_2,
    ]
  },
  {
    id: top2_i2,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p4_1,
      p4_2,
    ]
  },
  {
    id: top2_i3,
    type: 'blue',
    ref: 'top2_i3',
    farName: 'top2',
    sonName: '_i3',
    son: [
      p5_1
    ]
  },
  {
    id: top2_i4,
    type: 'blue',
    ref: 'top2_i4',
    farName: 'top2',
    sonName: '_i4',
    son: [
      p6_1
    ]
  },
  {
    id: top3_i1,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p7_1
    ]
  },
  {
    id: top3_i2,
    type: 'blue',
    ref: 'top3_i2',
    farName: 'top3',
    sonName: '_i2',
    son: [
      p8_1,
    ]
  },
  {
    id: top3_i3,
    type: 'blue',
    ref: 'top3_i3',
    farName: 'top3',
    sonName: '_i3',
    son: [
      p9_1,
    ]
  },
  {
    id: top3_i4,
    type: 'blue',
    ref: 'top3_i4',
    farName: 'top3',
    sonName: '_i4',
    son: [
      p10_1,
    ]
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top1_i2: -13,
  top1_i3: -8,
  top2_i1: 16,
  top2_i2: -21,
  top2_i3: -8,
  top2_i4: -16,
  top3_i1: 8,
  top3_i2: -3,
  top3_i3: -10,
  top3_i4: -20,
}

export default {
  title: '全新上线-我和我们的故事',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
